import React, { useState } from 'react';
import { Modal } from 'components/Modal/Modal';
import styles from './OmnigrowUpdateModal.module.scss';
import { CloseIcon } from 'icons/close';
import { InfoIcon } from 'components/Icons/Icons';
import { IconButton } from 'components/Button/IconButton';
import { FeatureFlagged } from 'components/FeatureFlagged/FeatureFlagged';
import { FLAGS } from 'hooks/useFlags';
import { persistentCookie, useCookie } from 'utils/cookie';
import cls from 'classnames';

const TIMES_TO_SHOW_UPDATES = 3;

type OmnigrowUpdateModalProps = {
  onClose: () => void;
};

export const OmnigrowUpdateModal = () => {
  const [isOpen, setIsOpen] = useState(true);

  const state = useCookie<number>(persistentCookie.omnigrowUpdateModal, (value?: string) =>
    value ? Number(value) : 0,
  );

  function onDismiss() {
    state.setCookie(state.value + 1);
    setIsOpen(false);
  }

  return (
    <FeatureFlagged flag={FLAGS.omnigrowUpdatePopup} fallbackStrategy={{ type: 'ignore' }}>
      {state.expired || state.value >= TIMES_TO_SHOW_UPDATES
        ? null
        : isOpen && (
            <Modal
              onClose={onDismiss}
              modalId="omnigrow-update-modal"
              className={cls(styles.omnigrowUpdateModal, 'modal')}
              blurBackground
              modalHeader={
                <div className={styles.modalHeader}>
                  <div className={styles.modalTitle}>
                    <IconButton icon={<InfoIcon stroke="var(--gray-3)" />} rounded />
                    <span className="subheading-large">OmniGrow Update </span>
                  </div>
                  <div className={styles.closeIcon} onClick={onDismiss}>
                    <CloseIcon />
                  </div>
                </div>
              }
              modalBody={<OmnigrowUpdate onClose={onDismiss} />}
            />
          )}
    </FeatureFlagged>
  );
};

export const OmnigrowUpdate = ({ onClose }: OmnigrowUpdateModalProps) => {
  return (
    <div className={styles.modalBody}>
      <div>
        <p className={cls(styles.modalText, 'body-large text-60')}>
          At the start of the Hatchening on{' '}
          <span className="text-100">December 1st, 2022 at 4:00pm UTC </span>, existing OmniGrow
          will be applied to all your Gribble Eggs that are not yet level 5. Gribble Eggs will no
          longer be able to be leveled up beyond this date. Any extra OmniGrow will remain in your
          balance.
        </p>

        <br />
        <p className={cls(styles.modalText, 'body-default text-60')}>
          You’re probably wondering about the future of OmniGrow – at the start of the Hatchening,
          how you can earn OmniGrow will also change. You can continue to earn OmniGrow both
          actively and passively through the following methods:
        </p>

        <ul className={styles.modalText}>
          <li className={cls(styles.modalText, 'body-default text-60')}>
            [Active] Referrals: 500 → 2500 OmniGrow per successful referral and 1 mint slot per
            successful referral
          </li>
          <li className={cls(styles.modalText, 'body-default text-60')}>
            [Passive] Holding Eggs/Gribbles: 14 → 100 OmniGrow per egg/gribble
          </li>
          <li className={cls(styles.modalText, 'body-default text-60')}>
            [Passive] Pairing owned Eggs/Gribbles with OG Breakers: 30 → 150 per day for each pair
          </li>
        </ul>
        <br />

        <p className={cls(styles.modalText, 'body-default text-60')}>
          OmniGrow rewards for referrals, holding Eggs/Gribbles, and pairing your Eggs/Gribbles with
          OG Breakers will increase. You will no longer be able to earn OmniGrow from daily game
          missions, weekly missions or Adrian’s Story.
        </p>
        <br />

        <p className={cls(styles.modalText, 'body-default text-60')}>
          We also understand that many of you have collected significant amounts of OmniGrow that
          you’re unable to spend on leveling up eggs further. We are actively working on a fun way
          to use OmniGrow, so please stay tuned!
        </p>
      </div>
      <button className="btn btn-primary btn-md" onClick={onClose}>
        OKAY, GOT IT
      </button>
    </div>
  );
};
